// B&T fest (Pellets): mehr als 1 Abladestelle

// state
const state = {
    totalKg: null, //int
    numberUnloadingPoints: null, //int 
    deliveryZip: '',
    deliveryCity: '',
    deliveryCountryCode: '',
    deliveryPeriod: ''
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
    setTotalKg(state, newValue) {
        state.totalKg = newValue;
    },
    setNumberUnloadingPoints(state, newValue) {
        state.numberUnloadingPoints = newValue;
    },
    setDeliveryZipAndCity(state, payload) {
        state.deliveryZip = payload.zip;
        state.deliveryCity = payload.city;
        state.deliveryCountryCode = payload.countryCode;
    },
    setDeliveryPeriod(state, newValue) {
        state.deliveryPeriod = newValue;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}